import axios from 'axios'
import { LOGINAPI_ADDRESS } from 'config'

interface UsersDataResponse {
  loginProgress: string
  verUser: boolean
}

export const getUsersProgress = async (): Promise<UsersDataResponse> => {
  const data = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  return data
}

// export const usersTwoFactor = async (username: string): Promise<any> => {
//   const config = {
//     headers: {
//       'Content-type': 'application/json',
//     },
//   }
//   console.log('callled')
//   const url = '/api/users/request-two-factor'
//   const { data } = await axios.post(url, {
//     username,
//   })
//   return data
// }

export const usersReset = async (username: string): Promise<any> => {
  const config = {
    headers: {
      'Content-type': 'application/json',
    },
  }
  const url = `${LOGINAPI_ADDRESS}/api/users/request-reset-password`
  const { data } = await axios.post(url, {
    username,
  })
  return data
}

export const usersVerifyCode = async (code: string, username: string): Promise<any> => {
  const config = {
    headers: {
      'Content-type': 'application/json',
    },
  }
  const url = `${LOGINAPI_ADDRESS}/api/users/verify-reset-code`
  const { data } = await axios.post(url, {
    code,
    username,
  })
  return data
}

// export const usersVerifyTwofactorCode = async (code: string, username: string): Promise<any> => {
//   const config = {
//     headers: {
//       'Content-type': 'application/json',
//     },
//   }
//   const url = '/api/users/verify-code'
//   const { data } = await axios.post(url, {
//     code,
//     username,
//   })
//   return data
// }

export const usersResendCode = async (username: string): Promise<any> => {
  const config = {
    headers: {
      'Content-type': 'application/json',
    },
  }
  const url = `${LOGINAPI_ADDRESS}/api/users/resend-code`
  const { data } = await axios.post(url, {
    username,
  })
  return data
}

export const usersResendAlternateCode = async (username: string): Promise<any> => {
  const config = {
    headers: {
      'Content-type': 'application/json',
    },
  }
  const url = `${LOGINAPI_ADDRESS}/api/users/resend-alernate-code`
  const { data } = await axios.post(url, {
    username,
  })
  return data
}

export const passwordUpdate = async (token: string, username: string, password: string): Promise<any> => {
  const config = {
    headers: {
      'Content-type': 'application/json',
    },
  }
  const url = `${LOGINAPI_ADDRESS}/api/users/reset-password`
  const { data } = await axios.post(url, {
    token,
    username,
    password,
  })
  return data
}
